<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable placeholder="ICCID/ICCIDS空格隔开"></el-input>
      </el-form-item>
      <el-form-item  prop="msisdn">
        <el-input v-model="queryParams.msisdn" clearable placeholder="MSISDN/MSISDNS空格隔开"></el-input>
      </el-form-item>
      <el-form-item  prop="cardStatus">
          <el-select v-model="queryParams.cardStatus" filterable placeholder="运营状态" @change="search" clearable multiple >
            <el-option value="2" label="待激活"></el-option>
            <el-option value="3" label="可测试"></el-option>
            <el-option value="4" label="已激活"></el-option>
            <el-option value="5" label="已停机"></el-option>
            <el-option value="6" label="预销户"></el-option>
            <el-option value="7" label="已销户"></el-option>
          </el-select>
        </el-form-item>
      <el-form-item  prop="limitStatus" >
        <el-select v-model="queryParams.limitStatus" filterable placeholder="是否区域限制" @change="search" clearable >
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleBatchImport"  v-hasPermi="['card:regionCard:batch:import']">批量添加</el-button>
        <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['card:regionCard:export']">导出</el-button>
        <el-button type="primary" icon="el-icon-refresh" :disabled="multiple"   @click="handleRefreshBatchCardRegion"  v-hasPermi="['card:regionCard:refreshBatch']" >刷新</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple"  @click="handleRemoveCardRegion"  v-hasPermi="['card:regionCard:remove']" >移除区域</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableData" border  @selection-change="handleSelectionChange" @sort-change="tableSortChange" v-loading="loading">
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" min-width="200px" fixed>
        <template slot-scope="{row}">
          <el-link type="success" :underline="false" @click='jumpButton(row.iccid)'>{{row.iccid}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center" min-width="140px"></el-table-column>
      <el-table-column prop="cardStatus" label="运营状态" align="center" min-width="140px"></el-table-column>
      <el-table-column prop="limitStatus" label="区域限制" align="center">
        <template slot-scope="{row}">
          <i v-if="row.queryLimitStatus == '0'" class="el-icon-loading"></i>
          <span v-else-if="row.queryLimitStatus =='1'">{{row.limitStatus == '0'?'否':'是'}}</span>
          <span v-else-if="row.queryLimitStatus =='2'">查询失败：{{row.limitStatus == '0'?'否':'是'}}</span>
          <span v-else>{{row.limitStatus == '0'?'否':'是'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="regionLimit" label="限制区域" align="center"  width="100px" sortable="custom">
        <template slot-scope="{row}">
          <i v-if="row.queryRegionLimit == '0'" class="el-icon-loading"></i>
          <span v-else-if="row.queryRegionLimit =='1'">{{row.regionLimit}}</span>
          <span v-else-if="row.queryRegionLimit =='2'">查询失败：{{row.regionLimit}}</span>
          <span v-else>{{row.regionLimit}}</span>
        </template> 
      </el-table-column>
      <el-table-column prop="currentProvince" label="当前区域" align="center"   width="160px" sortable="custom">
        <template slot-scope="{row}">
          <i v-if="row.queryCurrentRegion == '0'" class="el-icon-loading"></i>
          <span v-else-if="row.queryCurrentRegion =='1'">{{row.currentProvince}}</span>
          <span v-else-if="row.queryCurrentRegion =='2'">查询失败：{{row.currentProvince}}</span>
          <span v-else>{{row.currentProvince}}</span>
      </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"   width="160px"></el-table-column>
      <el-table-column label="操作" align="center" min-width="260px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" plain icon="el-icon-delete" @click="handleRemoveCardRegion(scope.row)" v-hasPermi="['card:regionCard:remove']">移除区域</el-button>
          <el-button size="mini" type="success" plain icon="el-icon-refresh" @click="handleRefreshCardRegion(scope.row)" v-hasPermi="['card:regionCard:refresh']">刷新当前区域</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 批量添加弹出框 -->
    <el-dialog title="区域限制卡批量添加" :visible.sync="batchFormOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="batchForm" :model="batchForm" :rules="batchRuleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态" prop="regionStatus">
              <el-radio v-model="batchForm.regionStatus" label="1" >上架</el-radio>
              <el-radio v-model="batchForm.regionStatus" label="2" >下架</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="字段类型" prop="fieldType">
              <el-radio v-model="batchForm.fieldType" label="1" >ICCID</el-radio>
              <el-radio v-model="batchForm.fieldType" label="2" >MSISDN</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="卡号列表" prop="iccids">
              <el-input v-model="batchForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="卡号范围" >
        <el-row>
          <el-col :span="11">
            <el-form-item prop="iccidStart">
              <el-input
                v-model="batchForm.iccidStart"
                clearable
                placeholder="包含开始值"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="iccidEnd">
              <el-input
                v-model="batchForm.iccidEnd"
                clearable
                placeholder="包含终止值"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBatchForm" :loading="submitLoading">确 定</el-button>
        <el-button @click="cancelBatchForm">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  cardRegionList,
  removeCardRegion,
  regionBatchCards,
  refreshBatchCardRegion,
  refreshCardRegion,
  exportRegionCard
} from "@/api/api.js"; //风控卡列表
import { exportControlCard } from "@/api/api.js"; //导出风控卡
export default {
  name:"regionCard",
  data() {
    return{
      //遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams:{
        iccid:undefined,
        msisdn:undefined,
        limitStatus:undefined,
        cardStatus:undefined
      },
      tableData:[],
      dateRange: [],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      page: 1,
      pageSize: 10,
      total:0,
      dialog:false,
      batchForm:{
        regionStatus:"1"
      },
      batchFormOpen:false,
      submitLoading:false,
      batchRuleForm: {
        regionStatus: [
          { required: true, message: "区域不能为空", trigger: "blur" },
        ],
        fieldType: [
          { required: true, message: "字段类型不能为空", trigger: "blur" },
        ],
      }
      
    }
  },
  methods: {
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      this.sortName = val.prop
      this.initData()
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize
      }
      this.loading = true;
      cardRegionList(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重试！");
          this.loading = false;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableData.clearSort();
      this.resetForm("queryForm");
      this.search();
    },
    
    // 导出
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
        order: this.sortOrder,
        sort: this.sortName,
      }
      exportRegionCard(params).then(res=>{
        this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success",
            offset:30
          });
      })
    },
    
    // 多选单选的值
    handleSelectionChange(selection){
      this.ids = selection.map(item => item.id);
      this.single = selection.length!=1;
      this.multiple = !selection.length;
    },
    //当亲区域查询
    handleRefreshCardRegion(row){
        refreshCardRegion({id : row.id}).then(res=>{
            this.$message({
              type: 'success',
              message: '更新成功'
            });
            this.initData()
        });
    },
    handleRemoveCardRegion(row){
        let ids = row.id;
        if(!!ids){
            ids = [row.id];
        }
        const cardIds = ids || this.ids;
        this.$confirm('是否确认将这些数据移除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids:cardIds
          };
          removeCardRegion(params).then(res=>{
              this.$message({
                type: 'success',
                message: '移除成功'
              });
              this.initData()
          });
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          });          
        });
       
    },
    handleRefreshBatchCardRegion(){
        const cardIds =  this.ids;
        let params = {
            ids:cardIds
        };
        refreshBatchCardRegion(params).then(res=>{
            this.$message({
              type: 'success',
              message: '更新处理中'
            });
            this.initData()
        });
       
    },
    handleBatchImport(){
      this.batchFormOpen = true;
    },
    submitBatchForm(){
      let { iccids } = this.batchForm;
      let params = {
        ...this.batchForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs["batchForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          regionBatchCards(params).then(res => {
              this.$notify.info({
                title: "提示",
                message: "区域限制批量操作已提交，请在任务中心查看进度",
                duration: 1000,
                offset:30
              });
              this.submitLoading = false;
              this.cancelBatchForm();
              this.resetQuery();
          }).catch(() => {
            this.submitLoading = false;
          })
        }
      });
    },
    cancelBatchForm(){
      this.resetForm('batchForm');
      this.batchFormOpen = false;
    },
    // 关闭弹窗
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
  
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
  },
  mounted() {

  },
  created() {
    this.initData()
  }
};
</script>
<style scoped lang="less">
</style>


